import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const SELECTOR_CONTAINER = '[data-pdp-upsell-products]';
const SELECTOR_SWIPER_CONTAINER = '[data-swiper-container]';
const SELECTOR_SWIPER_NEXT = '[data-swiper-next]';
const SELECTOR_SWIPER_PREV = '[data-swiper-prev]';

class PDPUpsellSection {
  private swiperInstances: Map<string, Swiper> = new Map();

  constructor() {
    this.init();
  }

  private init(): void {
    const containers = document.querySelectorAll(SELECTOR_CONTAINER);
    containers.forEach(container => {
      this.initializeSwiper(container as HTMLElement);
    });
  }

  private initializeSwiper(container: HTMLElement): void {
    const swiperContainerEl = container.querySelector(SELECTOR_SWIPER_CONTAINER) as HTMLElement;
    const nextEl = container.querySelector(SELECTOR_SWIPER_NEXT);
    const prevEl = container.querySelector(SELECTOR_SWIPER_PREV);

    if (!swiperContainerEl) return;

    const swiper = new Swiper(swiperContainerEl, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      spaceBetween: 4,
      navigation: {
        nextEl: nextEl as HTMLElement || undefined,
        prevEl: prevEl as HTMLElement || undefined,
      },
      breakpoints: {
        1100: {
          slidesPerView: 2,
        },
      },
      loop: false,
      keyboard: true,
      grabCursor: true,
    });

    // Store the swiper instance
    this.swiperInstances.set(container.getAttribute('data-pdp-upsell-products') || '', swiper);
  }

  public destroy(): void {
    this.swiperInstances.forEach(swiper => {
      swiper.destroy(true, true);
    });
    this.swiperInstances.clear();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PDPUpsellSection();
  });
} else {
  new PDPUpsellSection();
}
